import { render, staticRenderFns } from "./query-footer.vue?vue&type=template&id=2692cfd4"
import script from "./query-footer.vue?vue&type=script&lang=ts"
export * from "./query-footer.vue?vue&type=script&lang=ts"
import style0 from "./query-footer.vue?vue&type=style&index=0&id=2692cfd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports